import { Controller } from "@hotwired/stimulus"
import { pulseStep } from "../lib/tally"

// Versioned local rollouts, not randomized tests. Only fixed labels reach analytics.
export default class extends Controller {
  static values = { test: String, variant: String }

  connect() {
    if (document.documentElement.hasAttribute("data-turbo-preview")) return
    this.count("marketing-view", this.interval())
  }

  interval() {
    const value = this.element.querySelector('input[name="pr-bill"]:checked')?.value
    return ["month", "year"].includes(value) ? { interval: value } : {}
  }

  pick(event) {
    if (event.target.matches('input[name="pr-bill"]')) this.count("marketing-pick", this.interval())
  }

  go(event) {
    if (event.target.id === "shop-form") this.count("marketing-go", { tool: "estimate-builder" })
  }

  count(name, data) {
    if (!["home-flow:connected-first", "pricing-default:monthly-first"].includes(`${this.testValue}:${this.variantValue}`)) return
    pulseStep(name, { test: this.testValue, variant: this.variantValue, ...data }, { once: name === "marketing-view" })
  }
}
